exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button__sidebar[data-v-19e8f985]{width:100%;margin-bottom:2px;cursor:move}.is-disabled .button__sidebar[data-v-19e8f985]{opacity:.4}.sortable__ghost[data-v-19e8f985]{position:relative;width:33.33%;border-bottom:2px solid #3a8ee6;margin-top:2px;margin-bottom:2px}.sortable__ghost [type=button][data-v-19e8f985]{display:none}.sortable__ghost[data-v-19e8f985]:before{content:\"Drag it here\";background-color:#ecf5ff;color:#3a8ee6;position:absolute;left:50%;font-size:10px;border-radius:10px;line-height:15px;padding:0 10px;top:-6px;transform:translateX(-50%)}", ""]);

// exports
